import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SelectLanguageComponent } from './select-language/select-language.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LanguagePopoverComponent } from './select-language/popover/popover.component';

@NgModule({
  declarations: [
    SelectLanguageComponent,
    LanguagePopoverComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
  ],
  exports: [
    SelectLanguageComponent,
    LanguagePopoverComponent,
  ]
})
export class SelectLanguageComponentModule { }
